/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description <p>Возможные значения:</p>\n<ul>\n<li><b>0 - Uploaded</b>: Загружен</li>\n<li><b>1 - Uploading</b>: В процессе загрузки</li>\n<li><b>2 - DeletionPending</b>: В процессе удаления</li>\n</ul>\n
 */
export const trackUploadStatusSchema = z.union([z.literal(0), z.literal(1), z.literal(2)]).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>0 - Uploaded</b>: Загружен</li>\n<li><b>1 - Uploading</b>: В процессе загрузки</li>\n<li><b>2 - DeletionPending</b>: В процессе удаления</li>\n</ul>\n")